<template>
  <el-dialog
    :title="model.status == 3 ? '确认入库' : '结算'"
    :visible.sync="visible"
    width="600px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <template v-if="model.status == 3">
        <!-- <el-form-item label="入库单号" prop="stockin_number">
          <el-input v-model="model.stockin_number"></el-input>
        </el-form-item> -->
        <el-form-item label="入库日期" prop="stock_time">
          <el-date-picker
            v-model="model.stock_time"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="仓库" prop="stockroom_name">
          <CommodityParamsSelect
            v-model="model.stockroom_name"
            paramName="stockroom_name"
            table="purchase_orders"
          ></CommodityParamsSelect>
        </el-form-item> -->
        <!-- <el-form-item label="入库类别" prop="stockin_category">
          <CommodityParamsSelect
            v-model="model.stockin_category"
            paramName="stockin_category"
            table="purchase_orders"
          ></CommodityParamsSelect>
        </el-form-item> -->
      </template>
      <!-- <template v-if="model.status == 100">
        <el-form-item label="发票" prop="imgs">
          <upload v-model="model.imgs" :limit="1"></upload>
        </el-form-item>
        <el-form-item label="发票号" prop="invoice_number">
          <el-input v-model="model.invoice_number"></el-input>
        </el-form-item>
      </template> -->
      <!-- <el-form-item label="备注">
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item> -->

      <el-form-item class="mb-0">
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
        <el-button size="small" @click="visible = false">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { purchaseOrderUpdateStatus } from '@/service/getData'
import upload from '../../../components/upload.vue'
import CommodityParamsSelect from './CommodityParamsSelect.vue'
export default {
  components: {
    upload,
    CommodityParamsSelect,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        stockin_number: [
          { required: true, message: '必填项', trigger: 'change' },
        ],
        stock_time: [{ required: true, message: '必填项', trigger: 'change' }],
        stockroom_name: [
          { required: true, message: '必填项', trigger: 'change' },
        ],
        stockin_category: [
          { required: true, message: '必填项', trigger: 'change' },
        ],
        imgs: [{ required: true, message: '请上传发票', trigger: 'change' }],
        invoice_number: [
          { required: true, message: '请填写发票号', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (data.imgs.length > 0) {
            data.receipt = {
              name: data.imgs[0].name,
              path: data.imgs[0].path,
            }
          }

          let res = await purchaseOrderUpdateStatus(data)
          if (res.code == 0) {
            this.$emit('callback', res.data)
            this.visible = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>